import { combineReducers } from 'redux';

import errors from './errors';


export default combineReducers({
  errors,
});
